import React,{useEffect} from "react";
import {Helmet} from 'react-helmet';
import Style from '../styles/Home.module.css';
import { Link } from "react-router-dom";

import service1 from '../imgs/homePage/Content1/service1.jpg';
import service2 from '../imgs/homePage/Content1/service2.jpg';
import service3 from '../imgs/homePage/Content1/service3.jpg';
import service4 from '../imgs/homePage/Content1/service4.jpg';
import service5 from '../imgs/homePage/Content1/service5.jpg';
import service6 from '../imgs/homePage/Content1/service6.jpg';

const mapEmbedUrl = "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d415071.5387380142!2d-82.669582!3d35.633978!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6031325ca1b2f97b%3A0xbd3fef53f0beb782!2sDino%20Construction!5e0!3m2!1sen!2sus!4v1688691122782!5m2!1sen!2sus";
const shouldLoadEmbeddedMap = () => navigator.userAgent !== "ReactSnap";

const HomePage = () =>{
    const [hasMounted, setHasMounted] = React.useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        setHasMounted(shouldLoadEmbeddedMap());
      }, []);
    return(
        <div>
            <Helmet>
                <title>Dino Constructions - Your Trusted Home Renovation Experts</title>
                <meta name="description" content="Dino Constructions is a team of experts in home renovation and construction. We specialize in high-quality workmanship and exceptional customer service." />
                <meta property="og:title" content="Dino Constructions - Your Trusted Home Renovation Experts" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://dinoconstructions.com" />
                <link rel="canonical" href="https://dinoconstructions.com/"/>
                <meta property="og:description" content="Dino Constructions is a team of experts in home renovation and construction. We specialize in high-quality workmanship and exceptional customer service." />
            </Helmet>
        <div className={Style.Content1}>
            <div className={Style.introTitle}>
                <p className={Style.heroEyebrow}>Asheville area construction and renovation</p>
                <h1><span className={Style.h1ToRed} >Built right,</span><br></br> from concrete to roofing</h1>
                <p>Dino Construction helps homeowners improve, repair, and build with dependable crews for concrete, decks, fences, painting, roofing, stone patios, and block foundations.</p>
                <div className={Style.heroHighlights}>
                    <span>Free estimates</span>
                    <span>Local team</span>
                    <span>Residential projects</span>
                </div>
            </div>
            <div className={Style.buttonContainer}>
                <Link to='/ContactUs#Estimate'><button className={Style.Content1Btns}>Request A Quote</button></Link>
                <Link to='/Gallery'><button className={Style.Content1Btns}>View Projects</button></Link>
            </div>
        </div>
        <div className={Style.Content2}>
            <span className={Style.sectionKicker}>What we do</span>
            <h2>Construction services for the work your home actually needs</h2>
            <p>From repairs to larger upgrades, our team keeps projects clear, practical, and focused on lasting results.</p>
        </div>
        <div className={Style.ProcessSection}>
            <div className={Style.ProcessIntro}>
                <span className={Style.sectionKicker}>Our process</span>
                <h2>Clear steps from first call to final walkthrough</h2>
            </div>
            <div className={Style.ProcessGrid}>
                <div>
                    <span>01</span>
                    <h3>Talk Through the Project</h3>
                    <p>We listen to what you need, review the space, and answer early questions before recommending next steps.</p>
                </div>
                <div>
                    <span>02</span>
                    <h3>Estimate the Work</h3>
                    <p>We gather details, photos, measurements, and service needs so the estimate matches the real scope.</p>
                </div>
                <div>
                    <span>03</span>
                    <h3>Schedule and Build</h3>
                    <p>Once approved, we plan the work, show up ready, and keep the project moving with care and attention.</p>
                </div>
                <div>
                    <span>04</span>
                    <h3>Walk It Together</h3>
                    <p>We review the finished work with you so the final result is clean, complete, and ready to use.</p>
                </div>
            </div>
        </div>
        <div className={Style.Content3}>
            <div className={Style.serviceA}>
                <div className={Style.serviceB}><img className={Style.serviceAImg} src={service1} alt='Concrete Driveway' loading="lazy" decoding="async" width="720" height="450"/></div>
                <div className={Style.serviceAContent}>
                    <span className={Style.serviceTag}>Concrete</span>
                    <h3>Comprehensive Concrete Solutions</h3>
                    <p>Driveways, slabs, sidewalks, repairs, and maintenance finished with the strength and detail your property deserves.</p>
                    <Link to='/Concrete'><button className={Style.Content3LearnBtn}>Learn More</button></Link>
                </div>
           </div>
        </div>
        <div className={Style.Content4}>
            <div className={Style.serviceB}>
                <div className={Style.serviceBContent}>
                    <span className={Style.serviceTag}>Painting</span>
                    <h3>Professional Painting Services</h3>
                    <p>Interior and exterior painting, prep work, repairs, and touch-ups that help your home look clean and cared for.</p>
                    <Link to='/Paint'><button className={Style.Content3LearnBtn}>Learn More</button></Link>
                </div>
                <div className={Style.imgContainer} ><img className={Style.serviceBImg} src={service2} alt='House Paint' loading="lazy" decoding="async" width="720" height="450"/></div>
                
            </div>
        </div>
        <div className={Style.Content3}>
            <div className={Style.serviceA}>
            <div className={Style.serviceB} ><img className={Style.serviceAImg} src={service3} alt='Deck' loading="lazy" decoding="async" width="720" height="450"/></div>
                <div className={Style.serviceAContent}>
                    <span className={Style.serviceTag}>Outdoor living</span>
                    <h3>Custom Porches and Decks</h3>
                    <p>Create your dream outdoor space with custom porches and decks from Dino Construction. We offer design, installation, and repair services. Contact us today to learn more!</p>
                    <Link to='/Porches-Decks-Fences'><button className={Style.Content3LearnBtn}>Learn More</button></Link>
                </div>
           </div>
        </div>
        <div className={Style.Content4}>
            <div className={Style.serviceB}>
                <div className={Style.serviceBContent}>
                    <span className={Style.serviceTag}>Roofing</span>
                    <h3>Roofing Services </h3>
                    <p>Protect your property with expert roofing services from Dino Construction. We offer metal roofing, shingle installation, repair, and more.</p>
                    <Link to='/Roofing'><button className={Style.Content3LearnBtn}>Learn More</button></Link>
                </div>
            <div className={Style.imgContainer}  ><img className={Style.serviceBImg} src={service4} alt='Shingle Roof' loading="lazy" decoding="async" width="720" height="450"/></div>
            </div>
        </div>
        <div className={Style.Content3}>
            <div className={Style.serviceA}>
            <div className={Style.serviceB} ><img className={Style.serviceAImg} src={service5} alt='Stone Patio' loading="lazy" decoding="async" width="720" height="450"/></div>
                <div className={Style.serviceAContent}>
                    <span className={Style.serviceTag}>Masonry</span>
                    <h3>Custom Stone Patio Design and Installation</h3>
                    <p>Elevate your outdoor living space with custom stone patio design and installation from Dino Construction. Learn more about our services today!</p>
                    <Link to='/StonePatio'><button className={Style.Content3LearnBtn}>Learn More</button></Link>
                </div>
           </div>
        </div>
        <div className={Style.Content4}>
            <div className={Style.serviceB}>
                <div className={Style.serviceBContent}>
                    <span className={Style.serviceTag}>Foundations</span>
                    <h3>Block Foundation Services</h3>
                    <p>Ensure the safety and longevity of your property with expert block foundation services from Dino Construction. Learn more today!</p>
                    <Link to='/BlockFoundation'><button className={Style.Content3LearnBtn}>Learn More</button></Link>
                </div>
            <div className={Style.imgContainer}  ><img className={Style.serviceBImg} src={service6} alt='Block Foundation House' loading="lazy" decoding="async" width="720" height="450"/></div>
            </div>
        </div>
        <div className={Style.Content5}>
            <div className={Style.locationInfo}>
                <h2>Our Location</h2>
                <div className={Style.brLine}></div>
                <p>From Downtown to the Mountains <br></br> Dino Construction Builds Your Vision Anywhere in Asheville and Beyond</p>
                <Link to='/ContactUs#Estimate'><button className={Style.Content5Btns}>Request A Quote</button></Link>
            </div>
            <div className={Style.map}>
            {hasMounted && (
            <iframe src={mapEmbedUrl}
                    title="Map"
                    width="99.5%"
                    height="99%"
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"></iframe>
            )}
            </div>
        </div>
     </div>
    );
}

export default HomePage;
